import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import he from "./locales/he.json";

// Language configuration
export const languages = {
  en: { name: "English", dir: "ltr" },
  he: { name: "עברית", dir: "rtl" },
} as const;

export type Language = keyof typeof languages;

// Resources
const resources = {
  en: { translation: en },
  he: { translation: he },
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: Object.keys(languages),

    // Detection options
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: true,
    },
  });

// Update document direction when language changes
i18n.on("languageChanged", (lng: Language) => {
  const dir = languages[lng]?.dir || "ltr";
  document.documentElement.lang = lng;
  document.documentElement.dir = dir;
});

// Set initial direction
const currentLang = i18n.language as Language;
if (languages[currentLang]) {
  document.documentElement.lang = currentLang;
  document.documentElement.dir = languages[currentLang].dir;
}

export default i18n;
